"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideBarProvider = exports.SideBarContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _BookmarksContext = require("./BookmarksContext");
var _EpubReaderContext = require("./EpubReaderContext");
var _services = require("../services");
var _CopyrightContext = require("./CopyrightContext");
var _SearchContext = require("./SearchContext");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-console */ // Contexts
var SideBarContext = exports.SideBarContext = /*#__PURE__*/(0, _react.createContext)();
var SideBarProvider = _ref => {
  var {
    children
  } = _ref;
  var [showingStylePopover, toggleStylePopover] = (0, _react.useState)(false);
  var [showingReferencesPopover, toggleReferencesPopover] = (0, _react.useState)(false);
  var [openDrawer, setOpenDrawer] = (0, _react.useState)(false);
  var [tabSelected, selectTab] = (0, _react.useState)(0);
  var [showingTooltip, setShowingTooltip] = (0, _react.useState)(null);
  var [selectedAnnotation, setSelectedAnnotation] = (0, _react.useState)();
  var [snackBar, setSnackBar] = (0, _react.useState)(false);
  var [onHashChangeCallback, setOnHashChangeCallback] = (0, _react.useState)();
  var {
    handleUserBookmark
  } = (0, _react.useContext)(_BookmarksContext.BookmarksContext);
  var {
    sessionToken,
    uuid,
    bookTitle
  } = (0, _react.useContext)(_EpubReaderContext.EpubReaderContext);
  var {
    setCopyValue,
    getPercentageCharsCopied
  } = (0, _react.useContext)(_CopyrightContext.CopyrightContext);
  var {
    setOpen: setOpenSearch
  } = (0, _react.useContext)(_SearchContext.SearchContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  var handleDrawerActions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (evt, action) {
      switch (action) {
        case 'summary':
          selectTab(0);
          setOpenDrawer(true);
          trackService.trackAccessIndex({
            uuid,
            titleCover: bookTitle
          });
          break;
        case 'toggleBookmark':
          handleUserBookmark();
          break;
        case 'formatting':
          setTimeout(() => toggleStylePopover(true), 50);
          break;
        case 'references':
          setCopyValue(yield getPercentageCharsCopied());
          setTimeout(() => toggleReferencesPopover(true), 45);
          break;
        case 'search':
          setOpenSearch(true);
          break;
        default:
          console.log('handleDrawerActions called.');
      }
    });
    return function handleDrawerActions(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleTabChange = (_evt, newValue) => {
    selectTab(newValue);
    setOpenDrawer(true);
  };
  return /*#__PURE__*/_react.default.createElement(SideBarContext.Provider, {
    value: {
      showingStylePopover,
      toggleStylePopover,
      openDrawer,
      setOpenDrawer,
      tabSelected,
      selectTab,
      handleTabChange,
      handleDrawerActions,
      isDesktopView: (0, _core.useMediaQuery)('(min-width:600px)'),
      showingTooltip,
      setShowingTooltip,
      selectedAnnotation,
      setSelectedAnnotation,
      showingReferencesPopover,
      toggleReferencesPopover,
      snackBar,
      setSnackBar,
      onHashChangeCallback,
      setOnHashChangeCallback
    }
  }, children);
};
exports.SideBarProvider = SideBarProvider;
SideBarProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};